const buildTypographyVariant = (
  fontFamilyHeading: string,
  fontFamilyBody: string,
  fontSize: number,
  lineHeight: number,
  fontWeight: number,
  isHeading: boolean = false,
  isUppercase: boolean = false,
  letterSpacing: number
): TypographyVariant => ({
  fontFamily: isHeading ? fontFamilyHeading : fontFamilyBody,
  fontWeight,
  fontSize: `${fontSize}px`,
  lineHeight: `${lineHeight}px`,
  textTransform: isUppercase ? 'uppercase' : 'initial',
  letterSpacing: `${letterSpacing}px`,
});

type TextTransform =
  | 'none'
  | 'capitalize'
  | 'uppercase'
  | 'lowercase'
  | 'full-width'
  | 'full-size-kana'
  | 'inherit'
  | 'initial'
  | 'revert'
  | 'revert-layer'
  | 'unset';

interface TypographyVariant {
  fontFamily: string;
  fontSize: string;
  fontWeight: number;
  lineHeight: string;
  textTransform: TextTransform;
  letterSpacing: string;
}

const typographyVariants = () => {
  const weightLight = 300;
  const weightRegular = 400;
  const weightMedium = 500;
  const weightSemiBold = 600;

  const buildVariant = (
    fontSize: number,
    lineHeight: number,
    fontWeight: number,
    isHeading: boolean = false,
    isUppercase: boolean = false,
    letterSpacing: number = 0
  ) =>
    buildTypographyVariant(
      'Gilroy-SemiBold',
      'Inter',
      fontSize,
      lineHeight,
      fontWeight,
      isHeading,
      isUppercase,
      letterSpacing
    );
  return {
    huge: buildVariant(64, 72, weightSemiBold),
    h1: buildVariant(56, 72, weightRegular, true),
    h2: buildVariant(48, 64, weightRegular, true),
    h3: buildVariant(24, 32, weightRegular, true),
    h4: buildVariant(20, 24, weightRegular, true),
    h5: buildVariant(16, 24, weightRegular, true, true, 0.8),
    h6: buildVariant(14, 24, weightSemiBold, true, true, 0.7),
    h7: buildVariant(12, 16, weightSemiBold, true, true, 0.6),
    bodyLight: buildVariant(16, 24, weightLight),
    bodyRegular: buildVariant(16, 24, weightRegular),
    bodySmallLight: buildVariant(14, 24, weightLight),
    bodySmallRegular: buildVariant(14, 24, weightRegular),
    bodyMedium: buildVariant(16, 24, weightMedium),
    bodySmallMedium: buildVariant(14, 24, weightMedium),
    bodySemiBold: buildVariant(16, 24, weightSemiBold),
    bodySmallBold: buildVariant(14, 24, weightSemiBold),
    bodyXl: buildVariant(24, 32, weightRegular),
    caption: buildVariant(12, 16, weightRegular),
    captionMedium: buildVariant(12, 16, weightMedium),
    tiny: buildVariant(10, 16, weightRegular),
    header: buildVariant(32, 40, weightSemiBold),
  };
};

export const typography = {
  typography: {
    fontSize: '16px',
    fontFamily: { primary: '"Inter"', heading: '"Gilroy-SemiBold"' },
    size: {
      base: '16px',
      xxs: '10px',
      xs: '12px',
      sm: '14px',
      md: '16px',
      lg: '24px',
      xl: '32px',
    },
    weight: {
      light: 300,
      regular: 400,
      medium: 500,
      semiBold: 600,
    },
    lineHeight: {
      xs: '16px',
      sm: '24px',
      md: '24px',
      lg: '32px',
      xl: '48px',
    },
    variants: typographyVariants(),
  },
};
